import type { NodeEntry } from '@udecode/plate';
import { useEditorPlugin, usePluginOption } from '@udecode/plate/react';
import { useEffect, useRef, useState } from 'react';

import type { TFootnoteElement } from '../../lib';
import { FootnotesPlugin } from '../FootnotesPlugin';

export function useFootnoteList(opts?: { debounceMs?: number }) {    
    const plugin = useEditorPlugin(FootnotesPlugin);
    const changeRev = usePluginOption(FootnotesPlugin, '_changeRev');

    const [ footnotes, setFootnotes ] = useState<NodeEntry<TFootnoteElement>[]>(plugin.api.footnotes.getAll());
    const debounceTimer = useRef<ReturnType<typeof setTimeout>|null>(null);

    useEffect(() => {
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }

        setTimeout(() => {
            const newFootnotes = plugin.api.footnotes.getAll();
            setFootnotes(newFootnotes);
        }, opts?.debounceMs ?? 0);

        return () => {
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }
        };
    }, [ plugin, changeRev ]);

    return footnotes;
}
